import { useMemo, useRef } from 'react';
import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
export const useLoadTranslations = (namespace, translations) => {
    const { locale } = useLocale();
    const { addTranslations } = useTranslation(namespace);
    const removeTranslations = useRef(() => { });
    removeTranslations.current = useMemo(() => {
        const loadTranslations = async () => {
            return addTranslations({
                locale,
                translations: getTranslationsByLocale(translations, locale),
            });
        };
        loadTranslations();
        return () => {
            // Cleanup function if needed
        };
    }, [addTranslations, locale, translations]);
};
const getTranslationsByLocale = (translations, locale) => {
    const translationByLocale = translations[locale];
    if (!translationByLocale) {
        throw new Error('No translations found for the given locale');
    }
    return translationByLocale;
};
